import { useController } from 'react-hook-form'

import { TextAreaField, TextField, ToggleField } from '../../legacy-form-fields'
import { IglooWorksConnectionFormValues } from './igloo-works.schema'

const useTextFieldProps = (name: keyof IglooWorksConnectionFormValues) => {
  const { field, fieldState } = useController<IglooWorksConnectionFormValues>({ name })
  return {
    errorLabel: fieldState.error?.message,
    isError: Boolean(fieldState.error),
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    value: field.value ?? '',
  }
}

export const IglooWorksFields = () => {
  const clientId = useTextFieldProps('clientId')
  const clientSecret = useTextFieldProps('clientSecret')
  const permissionDoors = useTextFieldProps('permissionDoors')
  const visitorPermissionDoors = useTextFieldProps('visitorPermissionDoors')
  const residentToggle = useController<IglooWorksConnectionFormValues>({
    name: 'shouldAutoAssignApartmentDoor',
  })
  const visitorToggle = useController<IglooWorksConnectionFormValues>({
    name: 'shouldAutoAssignApartmentDoorVisitor',
  })

  return (
    <div className="integration-configuration">
      <TextField {...clientId} label="Client ID" placeholder="Enter IglooWork Client ID" />
      <TextField
        {...clientSecret}
        label="Client Secret"
        placeholder="Enter IglooWork Client Secret"
        type="password"
      />
      <ToggleField
        id="shouldAutoAssignApartmentDoor"
        label="Autoassign Resident's door access"
        name={residentToggle.field.name}
        value={residentToggle.field.value}
        onChange={residentToggle.field.onChange}
      />
      <ToggleField
        id="shouldAutoAssignApartmentDoorVisitor"
        label="Autoassign Visitor's door access"
        name={visitorToggle.field.name}
        value={visitorToggle.field.value}
        onChange={visitorToggle.field.onChange}
      />
      <TextAreaField
        {...permissionDoors}
        label="Permission Doors (JSON: name → door id)"
        placeholder='{"Elevator": "1244545677", "Gym": "12445555"}'
        rows={4}
      />
      <TextAreaField
        {...visitorPermissionDoors}
        label="Visitor Permission Doors (JSON: name → door id)"
        placeholder='{"Main Entrance": "1244545678"}'
        rows={4}
      />
    </div>
  )
}
